import Model, { belongsTo, type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Dayjs } from 'dayjs';
import type {
  TotalRevenueBreakdownItem,
  TotalRevenueHotel,
  TotalRevenueItem,
} from 'lumen/models';
import { calculateAndAssignCapacity } from 'lumen/utils/total-revenue/calculate-capacity';

export default class TotalRevenueDashboard extends Model {
  [Type] = 'total-revenue/dashboard' as const;

  @belongsTo('total-revenue/item', { async: false, inverse: null })
  declare summary: TotalRevenueItem;

  @hasMany('total-revenue/breakdown-item', { async: false, inverse: null })
  declare departments: HasMany<TotalRevenueBreakdownItem>;

  @hasMany('total-revenue/item', { async: false, inverse: null })
  declare portfolio: HasMany<TotalRevenueItem>;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get departmentList() {
    return [...this.departments];
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get portfolioList() {
    return [...this.portfolio];
  }

  calculateAndAssignCapacity(
    from: Dayjs,
    to: Dayjs,
    ...allHotels: TotalRevenueHotel[]
  ): void {
    calculateAndAssignCapacity(this.summary, from, to, ...allHotels);

    this.portfolio.forEach((item) => {
      if (item.subscription) {
        calculateAndAssignCapacity(item, from, to, item.subscription);
      }
    });

    this.departments.forEach((item) => {
      calculateAndAssignCapacity(item, from, to, ...allHotels);
    });
  }
}
